import { render, staticRenderFns } from "./UserValidSettingAdd.vue?vue&type=template&id=05512654&"
import script from "./UserValidSettingAdd.vue?vue&type=script&lang=js&"
export * from "./UserValidSettingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports